import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import moment from "moment";
import { GET_INVOICE_REPORT } from "../Schema/Report";

const useGetInvoiceByPaymentStatusReport = ({
  paymentStatus,
  fromDate,
  toDate,
  groupFeeType,
}) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const { refetch } = useQuery(GET_INVOICE_REPORT, {
    variables: {
      fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
      toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
      paymentStatus: paymentStatus,
      groupFeeType,
    },
    onCompleted: ({ getInvoiceReport }) => {
      setTableData(getInvoiceReport || []);
      setLoading(false);
    },
    onError: ({ message }) => {
      console.log("Error::", message);
    },
  });

  useEffect(() => {
    refetch();
  }, [paymentStatus, fromDate, toDate, groupFeeType]);

  return { tableData, loading };
};

export default useGetInvoiceByPaymentStatusReport;
